export const GET_PROMOACTIONS = "GET_PROMOACTIONS";
export const SET_PROMOS_FILTER = "SET_PROMOS_FILTER";
